import React from 'react';
import { useState } from 'react';

export const BoardsAccessories = ({product}) => {

  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  }

  return (
    <div className="col-md-3 col-sm-4 col-12 px-3 mb-4" onClick={handleClick} style={{width: '265px'}}>
      <div className="product-card product-card-2 border h-100">
        <div className=" px-1 h-100 d-flex flex-column justify-content-between">
          <div className="image p-2">
            <img src={product.imageUrl} alt="" className="img-fluid border"/>
          </div>
          <div className="description px-1 ">
            <p className="product-name">{product.label}</p>
            <div className=" d-flex justify-content-between">
              <span />
              <div class="checkbox-container">
              <input type="checkbox" className="custom-checkbox " checked={isChecked} />
            </div> 
           </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export const InstallationAccessories = ({product}) => {

  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  }
  
  return (
    
    <div className="col-md-3 col-sm-4 col-12 px-3 mb-4" onClick={handleClick} style={{width: '265px'}}>
        <div className="product-card product-card-2 border h-100">
          <div className=" px-1 h-100 d-flex flex-column justify-content-between">
            <div className="image p-2">
              <img src={product.imageUrl} alt="" className="img-fluid mw-100 mh-100 " style={{height: 150, width: 230}} />
            </div>
            <div className="description px-1 ">
              <p className="product-name">{product.label}</p>
              <div className=" d-flex justify-content-between">
                <span />
                <div class="checkbox-container">
              <input type="checkbox" className="custom-checkbox " checked={isChecked} />
            </div> 
            </div>
            </div>
          </div>
        </div>
      </div>
    
    
  )
}